<template>
  <div class="spanning-wrap" v-if="spanning">
    <a-spin class="spin-item" :spinning="spinning" />
  </div>
</template>

<script>
export default {
  props: {
    spinning:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading:false
    }
  },
  methods: {
    updateLoading(v) {
      this.loading = v
    }
  }
}
</script>
